import { RootState } from '@core/Store'

export const selectAppHeaderForcedFixedState = ({ appHeader }: RootState) =>
  appHeader.forcedFixedState

export const getIsAppHeaderVisible = ({ appHeader }: RootState) => appHeader.isAppHeaderVisible
export const getIsBalanceVisible = ({ appHeader }: RootState) => appHeader.isBalanceVisible
export const getIsDropDownOpen = ({ appHeader }: RootState) => appHeader.isDropDownOpen
export const getIsAppHeaderStickyEnabled = ({ appHeader }: RootState) => appHeader.isStickyEnabled
export const getIsHamburgerMenuOpen = ({ appHeader }: RootState) => appHeader.isHamburgerMenuOpen
export const getShouldDisableAppHeaderRender = ({ appHeader }: RootState) =>
  appHeader.shouldDisableAppHeaderRender
export const getShouldHideBackButton = ({ appHeader }: RootState) => appHeader.shouldHideBackButton
export const getBonusDescriptionToDisplay = ({ appHeader }: RootState) =>
  appHeader.bonusDescriptionToDisplay

export const selectIsPreviousPendingBetsSportsOnly = ({ appHeader }: RootState) =>
  appHeader.isPreviousPendingBetsSportsOnly

export const selectShouldAllowPendingRacingTicketCountPolling = (state: RootState) =>
  state.appHeader.shouldAllowPendingRacingTicketCountPolling
